import { Icon } from '@pwc/pwc-deals-ui';
import React from 'react';
import classnames from 'classnames';
import VersionStatus from '../../../../common/components/Pills/VersionStatus';
import '../EditConnectedContentNew.scss';

const SelectedConnectedContentItem = ({
  fullContent,
  onDelete,
  hideTextVersion,
}) => {
  return (
    <>
      <div
        data-testid="selected-content-content"
        className="selected-connected-content"
      >
        {fullContent.length &&
          fullContent.map((content) => (
            <div
              className="selected-content-container"
              data-testid={`selected-content-container-test-${content.contentId}`}
            >
              <p>{content.title}</p>
              <div className="shared-pill-close-icon-container">
                <VersionStatus
                  content={content}
                  allowDraftPill={false}
                  hideTextVersion={hideTextVersion}
                />
                <div className="delete-connected-content-button">
                  <button
                    type="button"
                    data-testid={`connected-content-button-delete-${content.contentId}`}
                    className={classnames('icon-button')}
                    onClick={() => onDelete(content)}
                  >
                    <Icon
                      name="close"
                      width={16}
                      className="fill icon-orange-theme"
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default SelectedConnectedContentItem;
